import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

// Import layout
import Layout from "../layouts/for-agencies";

// Import components
import Hero from "../components/hero";
import ForAgenciesTabs from "../components/forAgenciesTabs";
import ForAgenciesForm from "../components/forAgenciesForm";
import SEO from "../components/seo";

// Import styles
import "./styles/for-agencies.scss";

const ForAgenciesPage = () => {
  const data = useStaticQuery(graphql`
    {
      wpPage(title: { eq: "For Agencies" }) {
        featuredImage {
          node {
            sourceUrl
          }
        }
        title
        forAgenciesFields {
          forAgenciesIntro {
            description
            fieldGroupName
            title
          }
          forAgenciesForm {
            title
            paragraph
          }
        }
      }
    }
  `);

  const { wpPage } = data;
  return (
    <Layout>
      <SEO
        title={wpPage.title}
        description={wpPage.description}
        image={wpPage.featuredImage.node.sourceUrl}
      />
      <div className="for-agencies">
        <Hero
          customClass="services"
          format="image-left"
          title={wpPage.forAgenciesFields.forAgenciesIntro.title}
          description={wpPage.forAgenciesFields.forAgenciesIntro.description}
          buttonLink=""
          buttonText=""
          image={
            <StaticImage
              placeholder="TRACED_SVG"
              src="../assets/images/for-agencies-badge.png"
              alt="A badge represent who Mtn Craft is."
            />
          }
        />
        <ForAgenciesTabs data={wpPage} />
        <ForAgenciesForm data={wpPage} />
      </div>
    </Layout>
  );
};

export default ForAgenciesPage;
